import { stringify } from 'safe-stable-stringify';

/*
 * function replacer (key, value)
 * Handles proper stringification of Buffer and bigint output.
 */ const replacer = (_key, value)=>{
    // safe-stable-stringify does support BigInt, however, it doesn't wrap the value in quotes.
    // Leading to a loss in fidelity if the resulting string is parsed.
    // It would also be a breaking change for logform.
    if (typeof value === 'bigint') return value.toString();
    return value;
};
/**
 * Create message string for MESSAGE field in the transformable info.
 */ const messageSymbol = (info)=>{
    return stringify.configure({})(info, replacer);
};

export { messageSymbol };
//# sourceMappingURL=utils.js.map
